import { useRef, useEffect, useCallback } from 'react';

const SWIPE_THRESHOLD_PX = 32;

/**
 * Ürün kartında mobil yatay kaydırma (detay sayfasına gitmeden görsel değiştirme).
 */
export function useSwipeableProductImages(imageCount, onSwipe) {
  const containerRef = useRef(null);
  const touchStartRef = useRef(null);
  const blockLinkClickRef = useRef(false);
  const onSwipeRef = useRef(onSwipe);

  onSwipeRef.current = onSwipe;

  useEffect(() => {
    const el = containerRef.current;
    if (!el || imageCount <= 1) return undefined;

    const handleMove = (e) => {
      if (!touchStartRef.current) return;
      const touch = e.touches[0];
      const dx = Math.abs(touch.clientX - touchStartRef.current.x);
      const dy = Math.abs(touch.clientY - touchStartRef.current.y);
      if (dx > dy && dx > 8) {
        e.preventDefault();
      }
    };

    el.addEventListener('touchmove', handleMove, { passive: false });
    return () => el.removeEventListener('touchmove', handleMove);
  }, [imageCount]);

  const onTouchStart = useCallback(
    (e) => {
      if (imageCount <= 1) return;
      const touch = e.touches[0];
      touchStartRef.current = {
        x: touch.clientX,
        y: touch.clientY,
      };
    },
    [imageCount]
  );

  const onTouchEnd = useCallback(
    (e) => {
      if (!touchStartRef.current || imageCount <= 1) return;

      const touch = e.changedTouches[0];
      const deltaX = touch.clientX - touchStartRef.current.x;
      const deltaY = touch.clientY - touchStartRef.current.y;
      touchStartRef.current = null;

      if (Math.abs(deltaX) < SWIPE_THRESHOLD_PX || Math.abs(deltaX) < Math.abs(deltaY)) {
        return;
      }

      blockLinkClickRef.current = true;
      window.setTimeout(() => {
        blockLinkClickRef.current = false;
      }, 450);

      e.preventDefault();
      e.stopPropagation();

      if (deltaX > 0) {
        onSwipeRef.current('prev');
      } else {
        onSwipeRef.current('next');
      }
    },
    [imageCount]
  );

  const onClickCapture = useCallback((e) => {
    if (blockLinkClickRef.current) {
      e.preventDefault();
      e.stopPropagation();
    }
  }, []);

  return {
    containerRef,
    swipeHandlers: {
      onTouchStart,
      onTouchEnd,
      onClickCapture,
    },
    swipeEnabled: imageCount > 1,
  };
}
